module.exports = __webpack_public_path__ + "img/03.59539b7d.png";